import { type CompModel } from '@bynder-studio/render-core';
import CanvasManipulationCompositor from './CanvasManipulationCompositor';
import ScrollbarsManipulation from './Scrollbars/ScrollbarsManipulation';
import BaseManipulation from './BaseManipulation';
import ManipulationEmitter from './ManipulationEmitter';

class CanvasPreviewManipulation extends BaseManipulation {
    scrollbarsManipulation: ScrollbarsManipulation;

    compModel: CompModel = null;

    constructor(compositor: CanvasManipulationCompositor, containerDocument: Document) {
        const emitter = new ManipulationEmitter();
        super(compositor, containerDocument, emitter);
        const paramsForManipulators = [compositor, containerDocument, this.emitter, this.redraw] as const;
        this.scrollbarsManipulation = new ScrollbarsManipulation(...paramsForManipulators);
    }

    setPageInfo() {
        // Intentionally left blank to satisfy interface/abstract requirements
    }

    setCompModel(compModel: CompModel) {
        this.compModel = compModel;
        this.redraw();
    }

    redraw = () => {
        this.compositor.requestToDrawCompModel(this.compModel);
        this.scrollbarsManipulation.requestToDrawScrollbars();
    };

    onPlayingStateChange = (isPlayingState) => {
        this.compositor.isPlaying = isPlayingState;
    };

    prepareCanvasForSizeChange() {
        // Intentionally left blank to satisfy interface/abstract requirements
    }

    unsubscribe() {
        // Intentionally left blank to satisfy interface/abstract requirements
    }

    unsubscribeEvents() {
        this.scrollbarsManipulation.unsubscribe();
    }
}

export default CanvasPreviewManipulation;
